export const SALE_CHANNEL = {
  KOLORS_US: 'KOLORS_US',
  KOLORS_MX: 'KOLORS_MX',
  POS: 'POS'
}
